import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import { Box } from '@mui/material';
import { EmptyState, Typography, Menu} from '@getgo/chameleon-web-react-wrapper';
import classes from './main-nav-view.scss';
import { AlertStaticPictogram } from '@getgo/chameleon-pictograms/react';
import { GotoBlackYellowIcon } from '@getgo/chameleon-icons/react';
import st from 'core/shared-translations';

const t = defineMessages({
  'mobile-access.title': {
    id: 'mobile-access.title',
    defaultMessage: 'GoTo Developers isn’t available on mobile yet',
    description: 'The about us link',
  },
  'mobile-access.subtitle': {
    id: 'mobile-access.subtitle',
    defaultMessage: 'Switch over to a desktop browser for full functionality.',
    description: 'The terms of service link',
  },
});


export const MobileView = () => (
  <Box>
    <Menu className={classes['navContainer']} role="menu" aria-label="navbar">
      <Box className={classes['navContainerTitle']}>
        <GotoBlackYellowIcon size="50px" />
        <Typography variant="body-large">
          <FormattedMessage {...st['shared.navbar.app-title']} />
        </Typography>
      </Box>
    </Menu>
    <Box className={classes['mobileViewBody']}>
      <Box p={4}>
        <EmptyState
          title={
            <Typography variant="body-medium-strong">
              <FormattedMessage {...t['mobile-access.title']} />
            </Typography>
            }
          icon={<AlertStaticPictogram />}>
          <FormattedMessage {...t['mobile-access.subtitle']} />
        </EmptyState>
      </Box>
    </Box>
  </Box>
);


export default MobileView;
